























































































import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator'
import { AssetsModule } from '@/store/modules/asset'
import { AssetFile } from '@/store/modules/asset'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import { FramePuzzleModule, PuzzleFormat } from '@/store/modules/framePuzzle'
import { FramePuzzleAssetUsage } from '@/components/products/framepuzzle/util/FramePuzzleAssetUsage'
import ImageUpload from '@/components/products/framepuzzle/FramePuzzleImageUpload.vue'

@Component({
    name: 'design-puzzle-image',
    components: { ImageUpload }
})

export default class DesignPuzzleImage extends Vue {
    @Prop() public hasOverlay!: boolean
    private imageConfirmable = false

    get selectedAssets() {
        return AssetsModule.selectedAssets
    }

    get userFormat() {
        return FramePuzzleModule.userFormat
    }

    get hasPortrait() {
        if (FramePuzzleModule.parts === '45') {
            return false
        }
        return true
    }

    get error() {
        return ToolbarModule.errorKeys.length !== 0
    }

    setLandscapeFormat() {
        FramePuzzleModule.SetPuzzleFormat(PuzzleFormat.LANDSCAPE)
        FramePuzzleModule.SetUserFormat("landscape")

    }

    setPortraitFormat() {
        if (this.hasPortrait) {
            FramePuzzleModule.SetPuzzleFormat(PuzzleFormat.PORTRAIT)
            FramePuzzleModule.SetUserFormat("portrait")
        }
    }

    isLandscape() {
        return FramePuzzleModule.userFormat === "landscape"
    }

    isPortrait() {
        return FramePuzzleModule.userFormat === "portrait"
    }

    mounted() {
        let usageName = "frameimage"
        let asset = FramePuzzleModule.activeAssets[usageName]
        if (asset) {
            FramePuzzleAssetUsage.prepareCollageUsage(asset, usageName)
            AssetsModule.Select(asset)
            if (this.userFormat !== '') {
                ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
            }
        } else if (AssetsModule.assets.length > 0) {
            let firstAsset = AssetsModule.assets.slice().reverse()[0]
            FramePuzzleAssetUsage.prepareCollageUsage(firstAsset, usageName)
            AssetsModule.Select(firstAsset)
            if (this.userFormat !== '') {
                ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
            }
            FramePuzzleModule.SetActiveAsset([usageName, firstAsset])
        } else {
            AssetsModule.Select()
        }
    }

    confirm() {
        let currentUsage = "frameimage"
        if (!ToolbarModule.errorKeys.includes(currentUsage)) {
            ToolbarModule.SetConfirmed(!ToolbarModule.confirmed)
        }
    }

    evaluateConfirmable() {
        let newSelectedAssets = this.selectedAssets
        let usagename = "frameimage"
        if (this.userFormat) {
            if (newSelectedAssets.length !== 0) {
                if (this.error) {
                    this.imageConfirmable = false
                    return
                }
                this.imageConfirmable = true
                return
            } else {
                for (let i = 0; i < AssetsModule.validAssets.length; i++) {
                    let asset = AssetsModule.validAssets[i]
                    let usage = asset.usage[usagename]
                    if (usage) {
                        this.imageConfirmable = false
                        return
                    }
                }
            }
        }
        this.imageConfirmable = false
    }

    @Watch('selectedAssets')
    selectedAssetsChanged(newSelectedAssets: AssetFile[]) {
        this.evaluateConfirmable()
    }

    @Watch('userFormat')
    userFormatChanged(newFormat: string) {
        if (ToolbarModule.deactivated !== 0) {
            let asset = FramePuzzleModule.activeAssets["frameimage"]
            if (asset) {
                ToolbarModule.SetDeactivated(ToolbarDeactivations.None)
            }
        }
        let usagename = "frameimage"
        if (newFormat !== '') {
            let newSelectedAssets = AssetsModule.selectedAssets
            if (newSelectedAssets.length !== 0) {
                if (this.error) {
                    this.imageConfirmable = false
                    return
                }
                this.imageConfirmable = true
                return
            } else {
                for (let i = 0; i < AssetsModule.validAssets.length; i++) {
                    let asset = AssetsModule.validAssets[i]
                    let usage = asset.usage[usagename]
                    if (usage) {
                        this.imageConfirmable = false
                        return
                    }
                }
            }
        }
        this.imageConfirmable = false
    }

    @Watch('error')
    errorChanged(newError: boolean) {
        if (newError) {
            this.imageConfirmable = false
        } else {
            this.evaluateConfirmable()
        }
    }

    @Watch('imageConfirmable')
    imageConfirmableChanged(newImageConfiramble: boolean) {
        this.$emit('confirmableChanged', newImageConfiramble)
    }

    beforeDestroy() {
        if (ToolbarModule.deactivated === 0) {
            ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        }
    }
}
